import { styled } from "@mui/material";
import { Link } from "react-router-dom";

export const SimpleLink = styled(Link)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    }
}));
